module.exports = __webpack_public_path__ + "img/lk-hero-img-center.b7fcf06e.svg";